import { FeatureKinds, parseFeatureKinds } from './featureKind';
import { DEFAULT_VALIDITY_WINDOW_MS } from './featureSwitchesCache';
import { createRefreshingCache } from './refreshingCache';

/**
 * Fetches the `settings` value of the `feature_kinds` config row, or resolves
 * `undefined` where no such row exists yet.
 */
export type FeatureKindsLoader = () => Promise<unknown>;

export type FeatureKindsCacheOptions = {
  readonly validityWindowMs?: number;
  readonly onRefreshFailure?: (error: Error) => void;
};

export type FeatureKindsCache = {
  kinds: () => Promise<FeatureKinds>;
};

export function createFeatureKindsCache(
  load: FeatureKindsLoader,
  options: FeatureKindsCacheOptions = {}
): FeatureKindsCache {
  const kinds = createRefreshingCache(
    async () => parseFeatureKinds(await load()),
    () => parseFeatureKinds(undefined),
    {
      validityWindowMs: options.validityWindowMs ?? DEFAULT_VALIDITY_WINDOW_MS,
      onRefreshFailure: options.onRefreshFailure,
    }
  );

  return { kinds };
}
